import { SEARCH_SERVICE, TRANSPORT_LIST } from "../constant"


export const transportList = () => {
  
    return {
        type: TRANSPORT_LIST,
    }
}

export const serviceSearch = (query) => {
  
    return {
        type: SEARCH_SERVICE,
        query
    }
}